import { generatePolygonGroundPrimitiveOptions } from 'app/agriculture/FarmMain/MapRenderer/utils/generatePolygonGroundPrimitiveOptions';
import { generatePolygonPrimitiveOptions } from 'app/agriculture/FarmMain/MapRenderer/utils/generatePolygonPrimitiveOptions';
import { CesiumPrimitive } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumPrimitive';
import { useContext } from 'react';
import { TerrainModeContext } from 'app/agriculture/contexts/TerrainProviderContext';
import { CesiumGroundPrimitive } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumGroundPrimitive';

interface CesiumPolygonComponentProps {
    positions: Cesium.Cartesian3[];
    color: Cesium.Color;
    id: string | number;
    allowPicking: boolean;
}

export function CesiumPolygonComponent(props: CesiumPolygonComponentProps) {
    const { terrainEnabled } = useContext(TerrainModeContext);

    return terrainEnabled ? (
        <CesiumGroundPrimitive primitiveOptions={generatePolygonGroundPrimitiveOptions(props)} />
    ) : (
        <CesiumPrimitive primitiveOptions={generatePolygonPrimitiveOptions(props)} />
    );
}
